import React from 'react'
import Hero from './Hero'
import Info from './Info'
import { Helmet } from 'react-helmet-async'

const Services = () => {
    return (
        <>
            <Helmet>
                <title> Services - Website Design & Web Development Company In Nagpur</title>
                <link rel="canonical" href="/services"></link>
                <meta name="description"
                    content="Bluecoder is Web design and web devlelopment company in Nagpur provides Web & Mobile Development, Digital Marketing, ecomerce development and Search engine optimization"
                    data-rh="true" />

                <meta name="keywords"
                    content="landing page desing Nagpur, Website design company Nagpur, Web development company Nagpur, internet marketing company Nagpur, web development services Nagpur, seo services Nagpur, website designing services in Nagpur, digital marketing company Nagpur, Mobile app development, ecommerce devlopment Nagpur, online marketing company Nagpur, social media marketing company Nagpur" />
            </Helmet>
            <Hero />
            <Info />
        </>
    )
}

export default Services